/* eslint-disable camelcase */
import cabine from '../../../services/cabineApi';
import { gotErrorFromApi } from '../../../utils/api';
import store from '../../configureStore';
import {
  eraserList,
  getListOfPartners,
  loadingClientsList,
} from '../../duck/legado/clientsApp';
import {
  getCustomersDocumentsFromApi,
  getDocumentsListFromApi,
  gotCustomersDocumentsFromApi,
  gotDocumentsListFromApi,
} from '../../duck/legado/clientsApp/customersDocuments';
import {
  getListTransfers,
  getListTransfersError,
  loadingTransferList,
} from '../../duck/legado/transferApp';
import {
  setAccountCredtFilterOptions,
  setAccountDebtFilterOptions,
  setAgencyCredtFilterOptions,
  setAgencyDebtFilterOptions,
  setCnpjcpfCredtFilterOptions,
  setCnpjcpfDebtFilterOptions,
  setCodLegFilterOptions,
  setDigitCredtFilterOptions,
  setDigitDebtFilterOptions,
  setFinalDateFilterOptions,
  setFinalPeriodFilterOptions,
  setFinalValueFilterOptions,
  setIdTransacaoFilterOptions,
  setInitialDateFilterOptions,
  setInitialPeriodFilterOptions,
  setInitialValueFilterOptions,
  setNameCredtFilterOptions,
  setNameDebtFilterOptions,
  setPartnerFilterOptions,
  setSituationFilterOptions,
  settingFilter,
  setTypeAccountCredtFilterOptions,
  setTypeAccountDebtFilterOptions,
  setTypeTransactionOptions,
} from '../../duck/legado/transferApp/filter';
import { IInitialStateSeeder } from '../../duck/legado/transferApp/filter/interface';
import { SendLoginTokenAuth } from '../tokens';

export function getApiTransfer(data) {
  const seeder: IInitialStateSeeder = {
    value: {
      from: data.value.from,
      to: data.value.to,
    },
    time: {
      from: data.time.from,
      to: data.time.to,
    },
    credt: {
      name: data.credt.name,
      cpfcnpj: data.credt.cpfcnpj,
      agency: data.credt.agency,
      account: data.credt.account,
      digit: data.credt.digit,
      typeAccount: data.credt.typeAccount,
    },
    debt: {
      name: data.debt.name,
      cpfcnpj: data.debt.cpfcnpj,
      agency: data.debt.agency,
      account: data.debt.account,
      digit: data.debt.digit,
      typeAccount: data.debt.typeAccount,
    },
    partner: data.partner,
    dateFrom: data.dateFrom,
    dateTo: data.dateTo,
    idTransaction: data.idTransaction,
    type_transaction: data.type_transaction,
    codLegado: data.codLegado,
    status: data.status,
  };

  return (dispatch: any) => {
    dispatch(loadingTransferList());
    cabine
      .post(`/v1/legado/relatorio/transacoes`, seeder, SendLoginTokenAuth())
      .then((response: any) => {
        dispatch(getListTransfers(response.data));
      })
      .catch((error: any) => {
        dispatch(getListTransfersError());
        gotErrorFromApi(error, dispatch, eraserList);
      });
  };
}

export function setFinalDateOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setFinalDateFilterOptions({ dateTo: props }));
  };
}

export function setInitialDateOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setInitialDateFilterOptions({ dateFrom: props }));
  };
}
export function setTypeTransactionOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setTypeTransactionOptions({ type_transaction: props }));
  };
}

export function setCodLeg(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setCodLegFilterOptions({ codLegado: props }));
  };
}

export function setIdTranscao(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setIdTransacaoFilterOptions({ idTransaction: props }));
  };
}
export function setSituation(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setSituationFilterOptions({ status: props }));
  };
}
export function setNameDebt(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setNameDebtFilterOptions({ debt: { name: props } }));
  };
}
export function setNameCredt(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setNameCredtFilterOptions({ credt: { name: props } }));
  };
}
export function setAgencyCredt(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setAgencyCredtFilterOptions({ credt: { agency: props } }));
  };
}
export function setAgencyDebt(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setAgencyDebtFilterOptions({ debt: { agency: props } }));
  };
}
export function setDigitCredt(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setDigitCredtFilterOptions({ credt: { digit: props } }));
  };
}
export function setDigitDebt(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setDigitDebtFilterOptions({ debt: { digit: props } }));
  };
}
export function setTypeAccountCredt(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(
      setTypeAccountCredtFilterOptions({ credt: { typeAccount: props } })
    );
  };
}
export function setTypeAccountDebt(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setTypeAccountDebtFilterOptions({ debt: { typeAccount: props } }));
  };
}

export function setDocumentCredt(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setCnpjcpfCredtFilterOptions({ credt: { cpfcnpj: props } }));
  };
}
export function setDocumentDebt(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setCnpjcpfDebtFilterOptions({ debt: { cpfcnpj: props } }));
  };
}

export function setAccountCredt(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setAccountCredtFilterOptions({ credt: { account: props } }));
  };
}
export function setAccountDebt(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setAccountDebtFilterOptions({ debt: { account: props } }));
  };
}

export function setFinalValueOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setFinalValueFilterOptions({ value: { to: props } }));
  };
}

export function SetInitialPeriodOption(props: any) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setInitialPeriodFilterOptions({ time: { from: props } }));
  };
}
export function setFinalPeriodOption(props: any) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setFinalPeriodFilterOptions({ time: { to: props } }));
  };
}

export function setInitialValueOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setInitialValueFilterOptions({ value: { from: props } }));
  };
}

export function getAllPartnersList() {
  return (dispatch: any) => {
    cabine
      .get('/v1/legado/parceiros', SendLoginTokenAuth())
      .then((response: any) => {
        dispatch(getListOfPartners(response.data.parceiros));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, eraserList);
      });
  };
}

export function actionLoadingClientList() {
  return (dispatch: any) => {
    dispatch(loadingClientsList());
  };
}

export function setPartnerOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setPartnerFilterOptions(props));
  };
}

export function getClientDocuments(
  agency: any,
  account: any,
  digit: any,
  cpfCnpj: any
) {
  store.dispatch(getCustomersDocumentsFromApi());
  return (dispatch: any) => {
    cabine
      .get(
        `/v1/legado/clientes/documentos/${agency}/${account}/${digit}/${cpfCnpj}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        dispatch(gotCustomersDocumentsFromApi(response.data));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, eraserList);
      });
  };
}

export function getDocumentsList() {
  store.dispatch(getDocumentsListFromApi());
  return (dispatch: any) => {
    cabine
      .get(`/v1/legado/clientes/tipo/documentos`, SendLoginTokenAuth())
      .then((response: any) => {
        dispatch(gotDocumentsListFromApi(response.data));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, eraserList);
      });
  };
}
